import getApiClient from '@/plugins/api'
import moment from "moment/moment";

export default {
  loadItem() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`holidays/${itemId}`, {
      params: self.searchParams
    })
      .then((result) => {
        self.holiday = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  save() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    let method = 'post',
      endpoint = 'holidays',
      headers = {}

    if (itemId) {
      method = 'patch'
      endpoint = `holidays/${itemId}`
      headers['Content-Type'] = 'application/merge-patch+json'
    }

    self.success = false
    self.error = false
    self.errors = {}
    self.$store.commit('startLoading')
    api[method](endpoint, self.holiday, {headers: headers})
      .then(response => {
        self.holiday = response.data
        self.success = true
      })
      .catch(error => {
        self.error = true
        self.processErrors(error.response.data.violations)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  parseDate(dateString, format) {
    if (dateString.length >= 16) {
      return moment(dateString, format).toDate()
    }
  },

  processErrors(errors) {
    const self = this
    self.errors = {}

    errors.forEach(error => {
      self.errors[error.propertyPath] = error.message
    })
  },

  openCropper(files, model) {
    const self = this
    const image = files[0]

    this.croppingModel = model

    const reader = new FileReader()
    reader.readAsDataURL(image)
    reader.onload = e => {
      self.croppingImage = e.target.result
      self.showCropper = true
    }
  },

  closeCropper() {
    this.croppingImage = null
    this.showCropper = false
    this.croppingModel = null
  },

  setImage() {
    const { canvas } = this.$refs.imageCropper.getResult()
    switch (this.croppingModel) {
      case 'picture':
        this.holiday.picture = canvas.toDataURL('image/jpeg', 70)
        break;
    }
    this.croppingImage = null
    this.showCropper = false
    this.croppingModel = null
  },
}
